import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, mergeProps as _mergeProps, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex items-center" }
const _hoisted_2 = { class: "on-left" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_CountrySelect = _resolveComponent("CountrySelect")!
  const _component_q_input = _resolveComponent("q-input")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.icon)
        ? (_openBlock(), _createBlock(_component_q_icon, {
            key: 0,
            name: _ctx.icon
          }, null, 8, ["name"]))
        : _createCommentVNode("", true),
      _createVNode(_component_CountrySelect, {
        "model-value": _ctx.country,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_ctx.onCountryChanged($event)))
      }, null, 8, ["model-value"])
    ]),
    _createVNode(_component_q_input, _mergeProps({
      label: _ctx.label,
      "model-value": _ctx.nationalNumber,
      rules: _ctx.rules,
      mask: "(###) ###-####",
      "unmasked-value": "",
      "hide-bottom-space": ""
    }, _ctx.$attrs, {
      "onUpdate:modelValue": _ctx.onNationalNumberChanged,
      type: "tel",
      style: {"flex-grow":"1"}
    }), null, 16, ["label", "model-value", "rules", "onUpdate:modelValue"])
  ]))
}